import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { I18nService } from '@app/i18n/i18n.service';

@NgModule({
  imports: [CommonModule, TranslateModule],
  providers: [I18nService],
})
export class I18nModule {}
